export default __webpack_public_path__ + "static/media/do.0c068c9a.svg";